<nz-upload [nzAccept]="accept" [nzAction]="''" [nzBeforeUpload]="beforeUpload"
           [nzMultiple]="multiple" nzType="drag">
  <p class="ant-upload-drag-icon">
    <i nz-icon nzType="inbox"></i>
  </p>
  <p class="ant-upload-text">拖放文件至此</p>
  <p *ngIf="multiple" class="ant-upload-hint">
    可拖放複數文件
  </p>
</nz-upload>
